import { render, staticRenderFns } from "./shieldingPager.vue?vue&type=template&id=4d2260d0&scoped=true&"
import script from "./shieldingPager.vue?vue&type=script&lang=js&"
export * from "./shieldingPager.vue?vue&type=script&lang=js&"
import style0 from "./shieldingPager.vue?vue&type=style&index=0&id=4d2260d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2260d0",
  null
  
)

export default component.exports